<template>
    <div id="app" class="antialiased">
        <alert ref="alert"></alert>

        <div class="h-screen">
            <router-view v-slot="{ Component }">
                <transition name="fade" mode="out-in">
                    <component :is="Component" />
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    provide() {
        const $this = this;

        return {
            alert: {
                show() {
                    $this.$refs.alert.show(...arguments);
                },
                showValidationErrors() {
                    $this.$refs.alert.showValidationErrors(...arguments);
                },
                success() {
                    $this.$refs.alert.success(...arguments);
                },
                info() {
                    $this.$refs.alert.info(...arguments);
                },
                showResponseErrors() {
                    $this.$refs.alert.showResponseErrors(...arguments);
                }
            }
        }
    },
    mounted() {
        if(!window.appConfig) {
            this.$router.push({
                path: '/unavailable'
            })
        }
    },
    methods: {
        block() {
        }
    }
}
</script>

<style>
#app {
    overflow-x: hidden;
}
</style>
